// extracted by mini-css-extract-plugin
export default {"tip":"set-content-to-join_tip__QIjTd","textRow":"set-content-to-join_textRow__XJAGJ","addWrp":"set-content-to-join_addWrp__MSNmZ"};